import { Detail } from "../../../components/users/Detail.tsx";
import { useParams } from "react-router-dom";

export default function UsersIDPage() {
  const params = useParams();

  return (
    <div className="w-full h-full p-8 overflow-hidden">
      <Detail id={params.id!} />
    </div>
  );
}
